var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.vuexApiData.items),function(event){return (event)?_c('main-event',{key:event.sys.id,attrs:{"img":_vm.getImgLink(event.fields.coverImage && event.fields.coverImage.sys.id),"event":event}}):_vm._e()}))}
var staticRenderFns = []

export { render, staticRenderFns }